export const navLinks = [
  { label: '事件速览', href: '#overview' },
  { label: '时间线', href: '#timeline' },
  { label: '热度榜', href: '#ranking' },
  { label: '内幕争议', href: '#inside' },
  { label: '图集直击', href: '#gallery' },
  { label: '涉事主体', href: '#entities' },
];

export const tickerItems = [
  '本页持续更新，按时间线整理公开流传信息',
  '新增节点：相关方就传播问题再次作出说明',
  '热度榜重置：24 小时内讨论量再上高位',
  '内幕争议专区新增 3 条待核实说法',
  '图集更新：现场氛围类图片补充 6 张',
  '话题溯源：转发路径与首发时间被重新梳理',
];

export const stats = [
  { value: '128', suffix: '条', label: '已归档线索' },
  { value: '36', suffix: '个', label: '时间线节点' },
  { value: '9', suffix: '方', label: '涉事相关方' },
  { value: '24', suffix: 'h', label: '持续追踪中' },
];

export const quickEntries = [
  {
    icon: 'ri-article-line',
    title: '事件速览',
    desc: '三分钟看清整件事的来龙去脉与关键节点',
    tag: '入门必读',
    href: '#overview',
  },
  {
    icon: 'ri-time-line',
    title: '完整时间线',
    desc: '从初次曝光到最新进展，逐条按时间梳理',
    tag: '36 个节点',
    href: '#timeline',
  },
  {
    icon: 'ri-fire-line',
    title: '热度榜单',
    desc: '话题讨论量、转发路径与关注度实时排行',
    tag: '实时更新',
    href: '#ranking',
  },
  {
    icon: 'ri-eye-off-line',
    title: '内幕争议',
    desc: '流传说法与官方回应对照，哪些仍待核实',
    tag: '12 条待核实',
    href: '#inside',
  },
  {
    icon: 'ri-image-2-line',
    title: '图集直击',
    desc: '现场氛围、时间地点线索的公开图片汇总',
    tag: '封面驱动',
    href: '#gallery',
  },
  {
    icon: 'ri-pushpin-2-line',
    title: '涉事主体',
    desc: '以公开身份为线索，梳理各方在事件中的位置',
    tag: '9 方关联',
    href: '#entities',
  },
];

export const timelineItems = [
  {
    time: '第 01 天 · 23:40',
    title: '首批内容在私密群组内流传',
    desc: '当晚深夜，一组来源不明的图片在小范围群组内被转发，最初只在极小圈子内流转，尚未进入公开讨论。',
    tag: '起点',
    live: false,
  },
  {
    time: '第 02 天 · 09:12',
    title: '截图外溢至公开讨论区',
    desc: '有用户将群聊截图发到公开讨论区，话题首次进入大众视野，讨论量在数小时内快速攀升。',
    tag: '扩散',
    live: false,
  },
  {
    time: '第 02 天 · 18:05',
    title: '相关方首次作出回应',
    desc: '相关方通过简短声明确认"内容真实性有待核实"，并呼吁停止二次传播，话题热度达到第一波峰值。',
    tag: '回应',
    live: false,
  },
  {
    time: '第 03 天 · 11:30',
    title: '平台集中清理相关帖子',
    desc: '多个内容平台开始批量下架疑似相关内容，并提示用户注意隐私保护，讨论入口一度收紧。',
    tag: '处置',
    live: false,
  },
  {
    time: '第 04 天 · 20:48',
    title: '技术溯源讨论升温',
    desc: '有技术向网友提出对图片来源与拍摄时间的分析，认为部分内容存在剪辑痕迹，但结论并未获得统一认可。',
    tag: '溯源',
    live: false,
  },
  {
    time: '第 06 天 · 14:20',
    title: '新的"内幕"说法集中出现',
    desc: '一批自称知情者的账号集中发布说法，涉及传播链与动机推测，多数缺乏可验证证据，被列入待核实清单。',
    tag: '内幕',
    live: false,
  },
  {
    time: '第 09 天 · 08:00',
    title: '话题进入二次发酵阶段',
    desc: '伴随新一轮讨论，事件从"内容本身"转向"传播责任"与"隐私边界"，公共议题属性逐渐增强。',
    tag: '发酵',
    live: false,
  },
  {
    time: '最新 · 今日 16:30',
    title: '持续追踪，时间线仍在更新',
    desc: '目前各方仍在陆续回应，本页将按时间顺序继续补充新节点，帮助你看清完整脉络而不错过关键变化。',
    tag: '进行中',
    live: true,
  },
];

export const rankingToday = [
  { rank: 1, name: '首批内容流出当晚', heat: '986.4 万', width: '100%', trend: 'up' },
  { rank: 2, name: '相关方首次回应声明', heat: '742.1 万', width: '82%', trend: 'up' },
  { rank: 3, name: '平台集中清理动作', heat: '615.8 万', width: '68%', trend: 'flat' },
  { rank: 4, name: '技术溯源与剪辑质疑', heat: '498.3 万', width: '55%', trend: 'down' },
  { rank: 5, name: '知情者内幕说法合集', heat: '402.7 万', width: '44%', trend: 'up' },
  { rank: 6, name: '隐私边界公共讨论', heat: '318.9 万', width: '34%', trend: 'up' },
];

export const rankingWeek = [
  { rank: 1, name: '相关方首次回应声明', heat: '4321.6 万', width: '100%', trend: 'up' },
  { rank: 2, name: '首批内容流出当晚', heat: '3987.2 万', width: '92%', trend: 'flat' },
  { rank: 3, name: '知情者内幕说法合集', heat: '3210.5 万', width: '78%', trend: 'up' },
  { rank: 4, name: '平台集中清理动作', heat: '2764.8 万', width: '66%', trend: 'down' },
  { rank: 5, name: '隐私边界公共讨论', heat: '2210.3 万', width: '52%', trend: 'up' },
  { rank: 6, name: '二次发酵与责任追问', heat: '1866.4 万', width: '41%', trend: 'up' },
];

export const controversies = [
  {
    icon: 'ri-question-answer-line',
    claim: '流传说法：内容为首批流出当晚拍摄',
    answer: '待核实 · 目前仅依据文件名推断',
    verified: false,
  },
  {
    icon: 'ri-scissors-cut-line',
    claim: '流传说法：部分画面存在剪辑拼接痕迹',
    answer: '存在争议 · 技术向分析结论未统一',
    verified: false,
  },
  {
    icon: 'ri-user-shared-line',
    claim: '流传说法：传播链由特定账号主导',
    answer: '已部分澄清 · 转发路径仍在梳理',
    verified: true,
  },
  {
    icon: 'ri-shield-star-line',
    claim: '流传说法：平台曾提前预警并下架',
    answer: '已澄清 · 属常规内容治理流程',
    verified: true,
  },
];

export const galleryItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Blurred%20smartphone%20screen%20glowing%20in%20a%20dark%20room%2C%20anonymous%20hands%20holding%20device%2C%20warm%20amber%20and%20deep%20red%20lighting%2C%20moody%20abstract%20editorial%20photography%2C%20no%20identifiable%20faces%2C%20cinematic%20grain&width=800&height=1000&seq=psg-gallery-01&orientation=portrait',
    caption: '深夜屏幕光：最初流传的语境猜想',
    place: '线索 · 01',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Empty%20dramatic%20corridor%20interior%20with%20warm%20side%20light%20and%20long%20shadows%2C%20abstract%20architectural%20editorial%20photo%2C%20muted%20clay%20and%20amber%20tones%2C%20no%20people%2C%20cinematic%20atmosphere&width=800&height=1000&seq=psg-gallery-02&orientation=portrait',
    caption: '事件回应发生地：走廊氛围记录',
    place: '线索 · 02',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Pile%20of%20newspapers%20and%20printed%20documents%20on%20a%20wooden%20desk%2C%20warm%20desk%20lamp%20light%2C%20abstract%20editorial%20still%20life%2C%20cream%20and%20clay%20tones%2C%20top%20down%20composition%2C%20documentary%20mood&width=800&height=1000&seq=psg-gallery-03&orientation=portrait',
    caption: '纸质线索：公开报道的剪报汇总',
    place: '线索 · 03',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=City%20skyline%20at%20night%20with%20deep%20red%20warning%20glow%20and%20long%20exposure%20light%20trails%2C%20moody%20abstract%20editorial%20photography%2C%20warm%20amber%20highlights%2C%20no%20identifiable%20figures%2C%20cinematic&width=800&height=1000&seq=psg-gallery-04&orientation=portrait',
    caption: '城市夜色：话题在网络上蔓延的轨迹',
    place: '线索 · 04',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Studio%20microphone%20and%20recording%20equipment%20in%20dim%20warm%20light%2C%20abstract%20editorial%20detail%20shot%2C%20clay%20and%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20documentary%20mood&width=800&height=1000&seq=psg-gallery-05&orientation=portrait',
    caption: '录音备忘：各方回应的公开片段',
    place: '线索 · 05',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20shattered%20glass%20texture%20with%20warm%20backlight%20and%20deep%20red%20reflections%2C%20editorial%20abstract%20art%20photography%2C%20high%20contrast%2C%20grainy%20cinematic%20look%2C%20no%20figures&width=800&height=1000&seq=psg-gallery-06&orientation=portrait',
    caption: '碎裂的信任：隐私边界被讨论的隐喻',
    place: '线索 · 06',
  },
];

export const entities = [
  { role: '内容首发方', desc: '首批内容流出的初始节点，身份尚未公开确认', state: '未确认' },
  { role: '当事相关方', desc: '发布简短声明，称内容真实性有待核实', state: '已回应' },
  { role: '传播平台', desc: '集中下架疑似内容，提示用户注意隐私保护', state: '已处置' },
  { role: '技术溯源网友', desc: '提出画面剪辑与拍摄时间分析，结论未统一', state: '有争议' },
  { role: '自称知情者', desc: '集中发布内幕说法，多数缺乏可验证证据', state: '待核实' },
  { role: '法律从业者', desc: '就传播责任与隐私边界发表公开科普观点', state: '观点方' },
  { role: '媒体报道方', desc: '跟进事件进展，强调以公开信息为准', state: '跟进中' },
  { role: '普通讨论用户', desc: '事件热度的主要来源，议题转向传播责任', state: '活跃中' },
];